/**
 * Demo Page
 *
 * @since 1.0.33
 */

(() => {
	/**
	 * Demo Form
	 */
	const initPage = document.querySelector('#as-demo-form-init');
	const loaderPage = document.querySelector('#as-demo-form-loader');
	const embedPage = document.querySelector('#as-demo-form-embed-page');
	const embed = document.querySelector('#as-demo-form-embed');

	// If any of these three are gone, fire an error and exit this script
	if (!initPage || !embedPage || !embed) {
		alert('Demo page elements are missing.');
		console.error('Demo page elements are missing.');
		return;
	}


	/**
	 * Change the state of the loader
	 * @param {string} state  The state of the loader
	 */
	const loaderState = (state) => {
		if (state === "loader") {
			// Hide the initial form, set the height of the loader to the height of the form, and then show the loader
			loaderPage.style.height = initPage.offsetHeight + 'px';
			initPage.classList.add('hidden');
			loaderPage.classList.remove('hidden');
			loaderPage.classList.add('flex');
		}

		if (state === "init") {
			// Hide the loader and show the initial form
			loaderPage.classList.remove('flex');
			loaderPage.classList.add('hidden');
			initPage.classList.remove('hidden');
		}

		if (state === "embed") {
			// Hide the loader and show the embed
			loaderPage.classList.remove('flex');
			loaderPage.classList.add('hidden');
			embedPage.classList.remove('hidden');
		}
	};


	/**
	 * Create the main form
	 * @param {string} email  The email submitted from the initial form
	 */
	const createMainForm = (email) => {
		// If no email is provided, exit the function
		if (!email) {
			return;
		}

		// Now lets get the embed and grab the data-form-id attribute
		const formId = embed.getAttribute('data-form-id');

		// If theres no form ID, alert and exit the script
		if (!formId) {
			alert('Form ID is missing.');
			console.error('Form ID is missing.');
			return;
		}

		// Lets create the form
		hbspt.forms.create({
			region: "na1",
			portalId: "7222242",
			formId: formId,
			target: '#as-demo-form-embed',
			css: '',
			onFormReady: ()	=> {
				// Hide the loader and show the embed
				loaderState('embed');

				// Get the email field from the form
				const emailField = embedPage.querySelector('input[name="email"]');

				// After 300ms, set the email field value
				setTimeout(() => {
					emailField.value = email;
				}, 300);
			},
			onFormSubmitted: () => {
				// GTAG
				if (typeof gtag === 'function') {
					gtag('event', 'demo_form_submit', {
						'event_category': 'Demo Page',
						'event_label': 'Demo Form Submit'
					});
				}
			}
		});
	};


	// Now lets watch that event page
	if (initPage) {
		// Find the button and the email field
		const form = initPage.querySelector('form');
		let email = '';

		// If we have both lets watch em
		if (form) {
			// Add a submit event for our form
			form.addEventListener('submit', (e) => {
				// Prevent the default action
				e.preventDefault();

				// Show the loader
				loaderState('loader');

				// Grab the error element
				const errorElement = form.querySelector('.as-demo-error');

				// Get the email value
				email = form.querySelector('input[type="email"]').value;

				// If the email is empty, alert the user and exit the function
				if (!email) {
					// Set the error
					errorElement.textContent = 'Email is required.';

					// Unhide the error
					errorElement.classList.remove('hidden');

					// Hide the loader
					loaderState('init');

					return;
				}

				// Hide the error
				errorElement.classList.add('hidden');

				// Lets run a check against our API to see if the email is valid
				fetch(asApiUrl + 'demo-form/check-email', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						email: email
					})
				})
				.then(response => {
					if (response.ok) {
						return response.json();
					}
					throw new Error('Failed to connect to the API.');
				})
				.then(data => {
					// Check data
					if (!data) {
						throw new Error('Bad API data.');
					}

					// Now lets check the success message
					if (data.success) {
						// Fire the GTAG
						if (typeof gtag === 'function') {
							gtag('event', 'demo_form_email_submit', {
								'event_category': 'Demo Page',
								'event_label': 'Demo Form Email Submit'
							});
						}

						// Create the main form
						createMainForm(email);
					} else {
						throw new Error(data.data.message);
					}
				})
				.catch((error) => {
					// Set the error
					errorElement.textContent = error + " Please try again.";

					// Unhide the error
					errorElement.classList.remove('hidden');

					// Hide the loader
					loaderState('init');
				});
			});
		}
	}


	/**
	 * Accordion
	 */
	const accordion = document.querySelector('#as-demo-accordion');

	if (accordion) {
		// Grab each list item
		const items = accordion.querySelectorAll('li');

		// Loop each and watch the anchor tag inside
		items.forEach((item) => {
			// Get anchor
			const anchor = item.querySelector('a');

			// Get content
			const content = item.querySelector('.as-demo-accordion-content');

			// If we have the anchor tag, add a click event to it
			if (anchor) {
				anchor.addEventListener('click', (e) => {
					// Prevent the default action
					e.preventDefault();

					// Check for the expanded class in the item
					let expanded = item.classList.contains('expanded');

					// If expanded is false, check for expanded-default
					if (!expanded) {
						expanded = item.classList.contains('expanded-default');
					}

					// Now, lets expand or retract
					if (expanded) {
						item.classList.remove('expanded');
						item.classList.remove('expanded-default');
						content.style.maxHeight = null;
					} else {
						// Lets remove the expanded class from all the items
						items.forEach((i) => {
							i.classList.remove('expanded');
							i.classList.remove('expanded-default');
							i.querySelector('.as-demo-accordion-content').style.maxHeight = null;
						});

						item.classList.add('expanded');
						content.style.maxHeight = content.scrollHeight + 'px';
					}
				});
			}
		});
	}
})();